export const ROLE_PERMISSIONS = {
  "super-admin": [
    "vehicles",
    "feature-catalog",
    "images",
    "requests",
    "users",
    "email-settings",
    "flex-prices",
    "warranty",
    "warranty-transactions",
    "orders",
  ],
  "car-admin": ["vehicles", "feature-catalog", "flex-prices"],
  "image-admin": ["images"],
  "enquiry-admin": ["requests"],
};
